// mbscan manager-client の同名部品と共通。片側だけで変えない
import { Home, RotateCw } from 'lucide-react'

import { ErrorPanel } from '@/components/ui/error-panel'

// router の defaultErrorComponent。描画中・loader での想定外の例外を受ける。
// Provider や router の状態が壊れていても出せるよう、ErrorPanel（Card・Button だけに依存）で描画し、
// 遷移も router を使わず素の reload / href で行う
export function RouteErrorFallback() {
  return (
    <ErrorPanel
      title="画面を表示できませんでした"
      description="再読み込みしても解決しない場合は、ホームから再度お試しください。"
      action={{
        label: '再読み込み',
        icon: RotateCw,
        onClick: () => {
          window.location.reload()
        },
      }}
      secondaryAction={{ label: 'ホームへ戻る', href: '/', icon: Home }}
    />
  )
}
